// TermsAndConditions.js
import React from 'react';
import '../style/PrivacyPolicy.css'; // Reusing your existing CSS for consistency

export default function TermsAndConditions() {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1 className="privacy-title">Terms & Conditions</h1>
        <p className="privacy-updated"><strong>Last Updated:</strong> April 20, 2025</p>

        <p>
          Welcome to <span className="brand">CarsChalao</span>. By accessing or using our website, 
          you agree to be bound by these Terms and Conditions. Please read them carefully before using 
          <a href="https://carschalao.com" className="privacy-link"> https://carschalao.com</a>.
        </p>

        <h2 className="privacy-subtitle">1. Acceptance of Terms</h2>
        <p>
          By using this website, you confirm that you are at least 18 years of age or possess legal parental 
          or guardian consent. If you do not agree with any of these terms, you are prohibited from using or 
          accessing this site.
        </p>

        <h2 className="privacy-subtitle">2. Intellectual Property Rights</h2>
        <p>
          All content, including text, graphics, logos, and images on CarsChalao, is our property or the property 
          of our content suppliers and is protected by copyright laws. 
        </p>
        <ul>
          <li>You may view and print pages for personal, non-commercial use.</li>
          <li>You must not republish, sell, or duplicate material from our site without written consent.</li>
        </ul>

        <h2 className="privacy-subtitle">3. User Conduct</h2>
        <p>
          When using our site, especially the comments section, you agree not to:
        </p>
        <ul>
          <li>Post unlawful, defamatory, or obscene material.</li>
          <li>Engage in spamming or distribute viruses.</li>
          <li>Use automated scripts to collect data from the site.</li>
        </ul>

        <h2 className="privacy-subtitle">4. Disclaimer of Warranties</h2>
        <p>
          The information on CarsChalao is provided "as is" for general informational purposes only. While we 
          strive for accuracy, we make no warranties regarding the completeness or reliability of the automotive 
          reviews, prices, or news provided.
        </p>

        <h2 className="privacy-subtitle">5. Limitation of Liability</h2>
        <p>
          CarsChalao and its team shall not be held liable for any damages (including data loss or profit loss) 
          arising out of the use or inability to use the materials on our website.
        </p>

        <h2 className="privacy-subtitle">6. External Links</h2>
        <p>
          We may link to external websites. We are not responsible for the content or privacy practices of these 
          third-party sites. Use them at your own risk.
        </p>

        <h2 className="privacy-subtitle">7. Changes to Terms</h2>
        <p>
          CarsChalao reserves the right to revise these terms at any time without notice. By using this website, 
          you are agreeing to be bound by the then-current version of these Terms and Conditions.
        </p>

        <h2 className="privacy-subtitle">8. Governing Law</h2>
        <p>
          Any claim relating to CarsChalao's website shall be governed by the laws of our operating jurisdiction 
          without regard to its conflict of law provisions.
        </p>

        <h2 className="privacy-subtitle">Contact Us</h2>
        <p>
          For any clarifications regarding our terms: <br/>
          📧 <a href="mailto:info@carschalao.com" className="privacy-link">info@carschalao.com</a><br/>
          🌐 <a href="https://carschalao.com" className="privacy-link">https://carschalao.com</a>
        </p>
      </div>
    </div>
  );
}